module.exports = __webpack_public_path__ + "img/plus.342f7bcc.svg";